<template>
    <b-row>
        <b-col cols="12">
            <b-form-group>
                <v-select @search="fetchGroupMembers" v-model="selected"
                    :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" label="fullname" :options="members" multiple
                    class="select-size-lg p-1">
                    <template #option="{ photo, fullname }">
                        <b-avatar :src="photo" class="mr-1" size="32" />
                        <span> {{ fullname }}</span>
                    </template>
                </v-select>
            </b-form-group>
        </b-col>
    </b-row>
</template>

<script>
import { BRow, BCol, BFormGroup, BAvatar } from 'bootstrap-vue'
import vSelect from 'vue-select'
import store from '@/store'
import axios from '@axios'
export default {
    components: {
        BRow,
        BCol,
        BFormGroup,
        vSelect,
        BAvatar,
    },
    created() {
        // Fetch members when component is created
        if (this.searchOptions) {
            if (Array.isArray(this.searchOptions)) {
                // searchOptions is a list of groups
                this.fetchMultipleGroupMembers(this.searchOptions)
            } else if (this.searchOptions.id) {
                // searchOptions is a single group object
                this.fetchGroupMembers(this.searchOptions.id, () => {})
            }
        }
    },
    props: {
        initialMembers: {
            type: Array,
            default: () => []
        },
        searchOptions: {
            type: [Object, Array],
            default: () => ({})
        },
        searchType: {
            type: String,
            default: null
        }
    },


    methods: {
        async fetchMultipleGroupMembers(groupList) {
            // Reset members array
            this.members = [];
            // Collect all promises
            const promises = groupList.map(group => {
                const groupId = group.id || group;
                return this.fetchGroupMembers(groupId, () => {})
                    .catch(error => {
                        console.error(`Error fetching members for group ${groupId}:`, error);
                        return []; // Return empty array on error
                    });
            });
            
            try {
                // Wait for all requests to complete
                const results = await Promise.all(promises);
                
                // Flatten and combine all results
                const allMembers = results.flat();
                
                // Remove duplicates based on user ID
                const uniqueMembers = allMembers.reduce((acc, member) => {
                    const exists = acc.find(m => m.userguid === member.userguid || m.id === member.id);
                    if (!exists) {
                        acc.push(member);
                    }
                    return acc;
                }, []);
                
                this.members = uniqueMembers;
            } catch (error) {
                console.error('Error fetching multiple group members:', error);
                this.members = [];
            }
        },
        
        fetchGroupMembers(search, loading = () => {}) {
            return new Promise((resolve, reject) => {
                var uri = `/admin/f/cm/groupmembers/${search}`;
                if (search ) {
                    loading(true);
                    axios
                        .get(uri)
                        .then((response) => {
                            var data = response.data;
                            var responseData = JSON.parse(JSON.stringify(data));
                            
                            // Handle different response structures
                            let membersList = [];
                            if (responseData.users) {
                                membersList = responseData.users;
                            } else if (responseData.data) {
                                membersList = responseData.data;
                            } else if (Array.isArray(responseData)) {
                                membersList = responseData;
                            }

                            this.members = membersList;

                            loading(false);
                            resolve(membersList);
                        })
                        .catch(error => {
                            loading(false);
                            reject(error);
                        })
                } else {
                    resolve([]);
                }
            })
        },

    },
    watch: {
        selected: function (newVal, oldVal) {
            this.$emit("selectionChanged", newVal);

        },
        initialMembers: function (newVal, oldVal) {
            this.selected = newVal;

        },
        searchOptions: {
            handler(newVal, oldVal) {
                // When searchOptions changes, fetch members for the new group(s)
                if (newVal) {
                    if (Array.isArray(newVal)) {
                        // searchOptions is a list of groups
                        this.fetchMultipleGroupMembers(newVal)
                    } else if (newVal.id) {
                        // searchOptions is a single group object
                        this.fetchGroupMembers(newVal.id, () => {})
                    }
                }
            },
            deep: true,
            immediate: false
        }
    },
    data() {
        return {
            members: [],
            options: [],
            selected: this.initialMembers,
        }
    }
}
</script>